import { useAppSettingsDictionary } from '@/shared/api';
import { useAccountsInfo } from '../api';
import { useMemo } from 'react';
import { splitAccountsByType } from './calculations';

const useAccountsByType = () => {
  const { accountsInfo, isAccountsInfoLoading, accountsInfoError } =
    useAccountsInfo();
  const { appSettingsData, isAppSettingsLoading, appSettingsError } =
    useAppSettingsDictionary();

  const accountsByType = useMemo(() => {
    if (!accountsInfo || !appSettingsData) return;

    const {
      tradingSpotCodes,
      tradingInvestCodes,
      tradingLeverageCodes,
      tradingEarnCodes,
    } = appSettingsData.value;

    return splitAccountsByType(
      accountsInfo.accounts,
      tradingSpotCodes || [],
      tradingInvestCodes || [],
      tradingLeverageCodes || [],
      tradingEarnCodes || []
    );
  }, [accountsInfo, appSettingsData]);

  return {
    accountsInfo,
    accountsByType,
    isLoading: isAccountsInfoLoading || isAppSettingsLoading,
    error: accountsInfoError || appSettingsError,
  };
};

export { useAccountsByType };
